import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import type { SingleSparkTaskResponse } from 'types/SparkTasks';

export function useAddSparkTest(
  sparkStepID: string | undefined | null,
  outputBoardID: string | undefined | null
) {
  const queryClient = useQueryClient();

  const addSparkTest = () => {
    if (!sparkStepID || !outputBoardID) {
      Promise.reject('Spark Step ID can not be null');
    }

    const body = {
      data: {
        type: 'sparkTasks',
        attributes: {
          sparkStepID: sparkStepID,
        },
      },
    };
    return fetchWrapper<SingleSparkTaskResponse>({
      url: `SparkTasks/SparkStepTest`,
      method: 'POST',
      body: body,
    });
  };

  return useMutation('addSparkTest', addSparkTest, {
    onSuccess: async () => {
      await queryClient.invalidateQueries('sparkTask');
      await queryClient.invalidateQueries(['sparkStep', sparkStepID]);
      await queryClient.invalidateQueries('testSparkRun');
      await queryClient.invalidateQueries(['SparkOutputReferencesReferences']);
      queryClient.removeQueries(['sparkStepReferences']);
      await queryClient.invalidateQueries(['sparkDiagnostics']);
      await queryClient.invalidateQueries(['boardNodes', outputBoardID]);
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to add Test Record: ${error.message}`);
      }
    },
  });
}
